<script setup>
defineProps({
    factors: {
        required: true,
        type: Array,
    },
});
</script>
<script>
export default {
    name: 'PrimeFactorsDisplay',
};
</script>
<template>
    <div class="flex flex-wrap gap-2">
        <div v-for="(factor, index) in factors" :key="factor.value">
            <span>{{ factor.value }}</span>
            <sup v-if="factor.qty !== 1">{{ factor.qty }}</sup>
            <span v-if="index < factors.length - 1" class="ml-2">&times;</span>
        </div>
        <div>&nbsp;</div>
    </div>
</template>
